import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.998 22.761C10.908 22.761 9.82801 22.441 8.97801 21.811L4.67801 18.601C3.53801 17.751 2.64801 15.971 2.64801 14.561V7.12101C2.64801 5.58101 3.77801 3.94101 5.22801 3.40101L10.218 1.53101C11.208 1.16101 12.768 1.16101 13.758 1.53101L18.748 3.40101C20.198 3.94101 21.328 5.58101 21.328 7.12101V14.551C21.328 15.971 20.438 17.741 19.298 18.591L14.998 21.801C14.168 22.441 13.088 22.761 11.998 22.761ZM10.748 2.94101L5.75801 4.81101C4.90801 5.13101 4.15801 6.21101 4.15801 7.13101V14.561C4.15801 15.511 4.82801 16.841 5.57801 17.401L9.87801 20.611C11.028 21.471 12.968 21.471 14.128 20.611L18.428 17.401C19.188 16.831 19.848 15.511 19.848 14.561V7.12101C19.848 6.21101 19.098 5.13101 18.248 4.80101L13.258 2.93101C12.578 2.69101 11.418 2.69101 10.748 2.94101Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.15 14.189C13.96 14.189 13.77 14.119 13.62 13.969L9.36998 9.719C9.2305 9.57786 9.15228 9.38743 9.15228 9.189C9.15228 8.99057 9.2305 8.80014 9.36998 8.659C9.65998 8.369 10.14 8.369 10.43 8.659L14.68 12.909C14.97 13.199 14.97 13.679 14.68 13.969C14.53 14.109 14.34 14.189 14.15 14.189Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.85 14.232C9.66 14.232 9.47 14.162 9.32 14.012C9.18052 13.8709 9.10229 13.6804 9.10229 13.482C9.10229 13.2836 9.18052 13.0931 9.32 12.952L13.57 8.702C13.86 8.412 14.34 8.412 14.63 8.702C14.92 8.992 14.92 9.472 14.63 9.762L10.38 14.012C10.24 14.162 10.04 14.232 9.85 14.232Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }